import React from "react";
import { Typography } from "@mui/material";
import * as CONST from "../../Constants";
import HomeIcon from '@mui/icons-material/Home';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import NotesIcon from '@mui/icons-material/Notes';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
export default function PcpLocationItem(props) {
  return (
    <>
      {props.practice.name && (
        <Typography variant="title" fontWeight="600" color="#0faf97">
          <LocalHospitalIcon /> {props.practice.name}
        </Typography>
      )}
      {props.practice.disclaimer && (
        <>
          <br />
          <Typography fontWeight="300" color="#aaa">
            <NotesIcon /> {props.practice.disclaimer}
          </Typography>
        </>
      )}

      {props.practice.date_hours_available && (
        <>
          <Typography sx={{ fontWeight: "600" }}> <AccessTimeFilledIcon /> Hours </Typography>
          <Typography sx={{ fontWeight: "300" }}>
            <span style={{ marginLeft: "20px", whiteSpace: "pre-wrap"}}>
              {props.practice.date_hours_available.replaceAll("\n\n",", ").replaceAll("\n", " ")}
            </span>
          </Typography>
        </>
      )}
      {!props.practice.name && props.practice.address && (
        <Typography sx={{ fontWeight: "600" }}>{CONST.YOUR_PCP_ADDRESS}</Typography>
      )}
      <Typography>
        <HomeIcon /> {props.practice.address}
        <br />
        { props.practice.distance_from_patient && (<>
          ({props.practice.distance_from_patient} miles from your address)
        </>) }
      </Typography>
    </>
  );
}
